/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WerkenBijRouteImport } from './routes/werken-bij'
import { Route as TarievenRouteImport } from './routes/tarieven'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as MethodeRouteImport } from './routes/methode'
import { Route as LessenRouteImport } from './routes/lessen'
import { Route as InschrijvenRouteImport } from './routes/inschrijven'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as IndexRouteImport } from './routes/index'

const WerkenBijRoute = WerkenBijRouteImport.update({
  id: '/werken-bij',
  path: '/werken-bij',
  getParentRoute: () => rootRouteImport,
} as any)
const TarievenRoute = TarievenRouteImport.update({
  id: '/tarieven',
  path: '/tarieven',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
  id: '/sitemap.xml',
  path: '/sitemap.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const MethodeRoute = MethodeRouteImport.update({
  id: '/methode',
  path: '/methode',
  getParentRoute: () => rootRouteImport,
} as any)
const LessenRoute = LessenRouteImport.update({
  id: '/lessen',
  path: '/lessen',
  getParentRoute: () => rootRouteImport,
} as any)
const InschrijvenRoute = InschrijvenRouteImport.update({
  id: '/inschrijven',
  path: '/inschrijven',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/faq': typeof FaqRoute
  '/inschrijven': typeof InschrijvenRoute
  '/lessen': typeof LessenRoute
  '/methode': typeof MethodeRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/tarieven': typeof TarievenRoute
  '/werken-bij': typeof WerkenBijRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/faq': typeof FaqRoute
  '/inschrijven': typeof InschrijvenRoute
  '/lessen': typeof LessenRoute
  '/methode': typeof MethodeRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/tarieven': typeof TarievenRoute
  '/werken-bij': typeof WerkenBijRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/faq': typeof FaqRoute
  '/inschrijven': typeof InschrijvenRoute
  '/lessen': typeof LessenRoute
  '/methode': typeof MethodeRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/tarieven': typeof TarievenRoute
  '/werken-bij': typeof WerkenBijRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact'
    | '/faq'
    | '/inschrijven'
    | '/lessen'
    | '/methode'
    | '/sitemap.xml'
    | '/tarieven'
    | '/werken-bij'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact'
    | '/faq'
    | '/inschrijven'
    | '/lessen'
    | '/methode'
    | '/sitemap.xml'
    | '/tarieven'
    | '/werken-bij'
  id:
    | '__root__'
    | '/'
    | '/contact'
    | '/faq'
    | '/inschrijven'
    | '/lessen'
    | '/methode'
    | '/sitemap.xml'
    | '/tarieven'
    | '/werken-bij'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContactRoute: typeof ContactRoute
  FaqRoute: typeof FaqRoute
  InschrijvenRoute: typeof InschrijvenRoute
  LessenRoute: typeof LessenRoute
  MethodeRoute: typeof MethodeRoute
  SitemapDotxmlRoute: typeof SitemapDotxmlRoute
  TarievenRoute: typeof TarievenRoute
  WerkenBijRoute: typeof WerkenBijRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/werken-bij': {
      id: '/werken-bij'
      path: '/werken-bij'
      fullPath: '/werken-bij'
      preLoaderRoute: typeof WerkenBijRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tarieven': {
      id: '/tarieven'
      path: '/tarieven'
      fullPath: '/tarieven'
      preLoaderRoute: typeof TarievenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap.xml': {
      id: '/sitemap.xml'
      path: '/sitemap.xml'
      fullPath: '/sitemap.xml'
      preLoaderRoute: typeof SitemapDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/methode': {
      id: '/methode'
      path: '/methode'
      fullPath: '/methode'
      preLoaderRoute: typeof MethodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lessen': {
      id: '/lessen'
      path: '/lessen'
      fullPath: '/lessen'
      preLoaderRoute: typeof LessenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inschrijven': {
      id: '/inschrijven'
      path: '/inschrijven'
      fullPath: '/inschrijven'
      preLoaderRoute: typeof InschrijvenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContactRoute: ContactRoute,
  FaqRoute: FaqRoute,
  InschrijvenRoute: InschrijvenRoute,
  LessenRoute: LessenRoute,
  MethodeRoute: MethodeRoute,
  SitemapDotxmlRoute: SitemapDotxmlRoute,
  TarievenRoute: TarievenRoute,
  WerkenBijRoute: WerkenBijRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
